module.exports = {
    DEFAULT_WALL_WIDTH: 144, 
    DEFAULT_WALL_HEIGHT: 96,
}


// WEBPACK FOOTER //
// ./src/client/lib/constants.js